export const specialList = [
  {
    id: "special-time-narrative",
    title: "时光里的中国故事",
    subtitle: "年代叙事专题",
    cover: "https://readdy.ai/api/search-image?query=evocative%20collage%20of%20old%20Chinese%20town%20street%20at%20golden%20hour%2C%20vintage%20bicycles%20and%20tall%20trees%2C%20warm%20nostalgic%20tones%2C%20cinematic%20atmosphere%2C%20no%20text&width=1200&height=800&seq=special-time-2024&orientation=landscape",
    intro:
      "用影像丈量时代。专题汇集近年来最具代表性的年代剧，从小城工厂到戈壁绿洲，看普通人的命运如何在岁月里亮起微光。",
    groups: [
      { name: "东北往事", mediaIds: ["chang-ye-de-ji-jie", "ren-shi-jian"] },
      { name: "奋斗岁月", mediaIds: ["jue-xing-nian-dai", "shan-hai-qing"] },
    ],
  },
  {
    id: "special-scifi-universe",
    title: "仰望星空：科幻宇宙巡礼",
    subtitle: "硬核科幻专题",
    cover: "https://readdy.ai/api/search-image?query=deep%20space%20nebula%20with%20glowing%20stars%20and%20distant%20planet%2C%20cosmic%20blue%20and%20violet%20haze%2C%20cinematic%20epic%20scale%2C%20no%20text&width=1200&height=800&seq=special-scifi-2024&orientation=landscape",
    intro:
      "从红岸基地到黑石号，从土星轨道到厄拉科斯星球。专题带你走进那些重新定义想象的科幻影像，感受人类对未知的永恒好奇。",
    groups: [
      { name: "国产科幻", mediaIds: ["san-ti", "liu-lang-di-qiu-2"] },
      { name: "星际想象", mediaIds: ["xing-ji-chuan-yue", "dao-meng-kong-jian"] },
      { name: "沙丘纪元", mediaIds: ["sha-qiu-2"] },
    ],
  },
  {
    id: "special-suspense-night",
    title: "悬疑之夜：推理与人心",
    subtitle: "悬疑推理专题",
    cover: "https://readdy.ai/api/search-image?query=dark%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%2C%20mysterious%20lone%20figure%20with%20umbrella%2C%20moody%20teal%20and%20amber%20lighting%2C%20no%20text&width=1200&height=800&seq=special-suspense-2024&orientation=landscape",
    intro:
      "真相往往藏在细节里。专题精选口碑悬疑作品，从沿海小城到东北雪夜，跟着主角一起抽丝剥茧，直面人性的幽微之处。",
    groups: [
      { name: "国产悬疑", mediaIds: ["yin-mi-de-jiao-luo", "kuang-biao"] },
      { name: "国际推理", mediaIds: ["ji-sheng-chong", "guai-qi-wu-yu"] },
    ],
  },
  {
    id: "special-global-screen",
    title: "光影无界：世界影坛精选",
    subtitle: "海外佳作专题",
    cover: "https://readdy.ai/api/search-image?query=elegant%20global%20cinema%20concept%2C%20vintage%20film%20reels%20and%20projector%20light%20beams%20in%20dark%20theater%2C%20warm%20golden%20accents%2C%20cinematic%2C%20no%20text&width=1200&height=800&seq=special-global-2024&orientation=landscape",
    intro:
      "跨越语言与文化的边界。专题网罗全球高分电影与剧集，从好莱坞大片到韩剧经典，一次看遍世界影坛的精彩表达。",
    groups: [
      { name: "院线巨制", mediaIds: ["o-ben-hai-mo", "sha-qiu-2"] },
      { name: "剧集精品", mediaIds: ["qing-hui-da-1988", "quan-li-de-you-xi", "guai-qi-wu-yu"] },
    ],
  },
];